import React from 'react';

import { BuildPath } from '../../../helpers/Paths'

const ToolTipWrapper = (props:{id:string, children:any, className?:string}) => {

    const extraClass = props.className === undefined  ? "" : props.className;

    return (
        <div className={`tooltip-question-container ${extraClass}`}>

            <img 
                alt="" 
                className="tooltip-question"
                src={`${BuildPath()}/images/icons/QuestionMark2.png`} 
                data-tip="React-tooltip"
                data-tooltip-id={props.id} />  

            <div className="tooltip-pulse"></div>

            {props.children}

        </div>
    );
};

export default ToolTipWrapper;